<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>个人日志菜单使用说明:
					<span>1、查询关键字:姓名、日期</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button class="pre_btn_ok" @click="fun_note">追加批复</button>
			</template>
		</pre-base>

		<!-- 组件引入 -->
		<pre-tanone ref="log_note" @tan-event="refresh_data" />

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Method_Common
	} from '@/utils/loadhttpdata.js';
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue"),
			"pre-tanone": () => import("../per_old/pre_tan_one.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',

				t_data: [],

				list_user: [],
				sel_user: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "xz_user_log",
					"title": "卡信息",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"isMarkCode": "1",
					"step": "0",
					"sel_action": 'exp_user_log',
					"upd_action": 'exp15_user_log',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "姓名",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "截至日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						}
					],
					"parm": [{
							"name": "姓名",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "日期",
							"val": "",
							"key": "n_date",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "今日完成工作",
							"val": "",
							"key": "n_over",
							"type": "textareaedit",
							"class": "long5",
							"w": "1",
							"p": "1",
							"r": "0",
							"x": "2"
						},
						{
							"name": "未完成工作",
							"val": "",
							"key": "n_last",
							"type": "textareaedit",
							"class": "long5",
							"w": "1",
							"p": "1",
							"r": "0",
							"x": "3"
						},
						{
							"name": "需协调工作",
							"val": "1",
							"key": "n_help",
							"type": "textareaedit",
							"class": "long5",
							"w": "1",
							"p": "1",
							"r": "0",
							"x": "4"
						},
						{
							"name": "批复",
							"val": "",
							"key": "n_note",
							"type": "textarea",
							"class": "long5",
							"w": "1",
							"p": "1",
							"r": "0",
							"x": "5"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						},
						{
							"name": "姓名"
						},

						{
							"name": "日期"
						},
						{
							"name": "今日完成工作"
						},
						{
							"name": "未完成工作"
						},
						{
							"name": "需协调工作"
						},
						{
							"name": "点击量"
						},
						{
							"name": "批复"
						},
						{
							"name": "是否可以编辑"
						},
						{
							"name": "是否可以添加批复"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data();
				});
			},
			refresh_father: function(type, val, item) {
				// console.log(' 刷新父 type=' + type + ' val=' + val);
				this.row_id = val;
				this.t_data = item;

				// 点击
				let d = [];
				d.push(this.row_id);

				this.$post(
					api.http_method, Method_Common('_pnum_add', 0, '', d)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data);

				});
			},
			fun_note: function() {
				if (Number(this.row_id) == 0) {
					this.$message({
						message: '请选择要批复的信息!',
						type: 'warning'
					});
					return;
				}

				let parm = '';
				parm = JSON.stringify({
					"action": 'pnote',
					"title": '添加批复',
					"parm": [{
							"name": "主卡ID",
							"val": this.row_id,
							"key": "m_id",
							"type": "readonly"
						},
						{
							"name": "批复内容",
							"val": "",
							"key": "p_note"
						},
					],
					"parm_th": [{
						"name": "序号"
					}, {
						"name": "主单ID"
					}, {
						"name": "批复内容"
					}, {
						"name": "修改人"
					}, {
						"name": "修改时间"
					}, {
						"name": "是否编辑"
					}],
					"keyword": this.row_id
				});
				var that = this;
				this.$nextTick(function() {
					that.$refs['log_note'].load_data(parm);
				});



			}



		}
	};
</script>
<style scoped>

</style>